
var Instance = {}

// 浏览器检测代码
Instance.inspect = function() {
	var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
		( s = ua.match(/trident.([\d.]+)/)) ? Sys.ie = parseInt(s[1]) + 4 :
            (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
                    (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                            (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                                    (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;

    return Sys;
}

export default Instance;




// WEBPACK FOOTER //
// ./src/js/browser.js